<template>
  <el-drawer
    :visible.sync="show"
    size="600px"
    :withHeader="true"
    :show-close="false"
    :wrapperClosable="wrapperClosable"
    :direction="direction"
    :before-close="handleClose"
    class="station-detail"
    :open="open"
  >
    <!-- <el-scrollbar
      v-loading="loading"
      :native="false"
      view-class="container"
      style="height: calc(100vh - 40px)"
    >-->

    <div class="flex align-items-center" style="padding: 0 30px;">
      <div
        role="button"
        class="preview hd"
        :style="{
            'background-image': station.equip&&station.equip.equip_avatar
              ? `url(${station.equip.equip_avatar})`
              : `url(${nopic})`,
          }"
      >
        <div v-if="hasEquip" class="comm-tags">
          <el-tag
            v-if="station.equip.is_maintain"
            type="danger"
            effect="dark"
            class="comm-tag"
          >设备维护中</el-tag>
          <el-tag
            v-else-if="station.equip.is_online"
            type="success"
            effect="dark"
            class="comm-tag"
          >通讯正常</el-tag>
          <el-tag v-else type="info" effect="dark" class="comm-tag">通讯断开</el-tag>
        </div>

        <div v-if="hasEquip" class="updatetime flex-center">
          <i v-if="station.equip.is_online" class="el-icon-refresh" />
          <i v-else class="iconfont icon-disconnect" />
          <span
            v-if="station.equip.is_alarm"
            class="time ml-xs"
          >{{ station.equip.last_alarmon_time | parseTime("{y}-{m}-{d} {h}:{i}:{s}") }}</span>
          <span
            v-else-if="station.equip.is_running"
            class="time ml-xs"
          >{{ station.equip.last_parse_time | parseTime("{y}-{m}-{d} {h}:{i}:{s}") }}</span>
          <span
            v-else-if="station.equip.is_online"
            class="time ml-xs"
          >{{ station.equip.last_online_time | parseTime("{y}-{m}-{d} {h}:{i}:{s}") }}</span>
          <span
            v-else
            class="time ml-xs"
          >{{ station.equip.last_offline_time | parseTime("{y}-{m}-{d} {h}:{i}:{s}") }}</span>
        </div>
      </div>
      <div v-if="station.equip" class="bd flex column ml-lg" style="position: relative">
        <div style="position:absolute;top:40px;right:0px;">
          <f-image class="avatar huge circle" :src="station.qr_code_url"></f-image>
        </div>
        <div class="font-20 text-bold">
          {{ station.station_title }}
          <span class="ml ellipsis">{{ station.station_no }}</span>
        </div>
        <div class="mt-lg">关联设备：{{ station.equip.equip_name || '--'}}</div>
        <div class="mt-sm">设备类型：{{ station.equip.cate_title || "--" }}</div>
        <div class="mt-sm">所属车间：{{ station.equip.workshop_title || '--' }}</div>
        <div class="mt-sm">通讯模块：{{ station.equip.go || '--'}}</div>
      </div>
    </div>
    <el-tabs v-model="activeName" type="card" class="mt-lg">
      <el-tab-pane label="工单信息" name="first">
        <workorder-info
          v-if="show&&activeName == 'first'"
          :stationid="stationid"
          :random="station.random"
        />
      </el-tab-pane>
      <el-tab-pane label="工位绑定" name="second">
        <station-member
          v-if="show&&activeName == 'second'"
          :stationid="stationid"
          @change="$emit('change')"
        ></station-member>
      </el-tab-pane>
      <!-- <el-tab-pane label="设备分析" name="third" :lazy="true">
          <analysis :stationid="station.stationid" :random="station.random" />
      </el-tab-pane>-->
    </el-tabs>
    <!-- </el-scrollbar> -->
  </el-drawer>
</template>

<script>
import StationMember from "./StationMember.vue";
import { getStationApi } from "@/api/pp/stationApi";
// import { stationDetailApi } from "@/api/em/detailApi";

export default {
  name: "StationDetail",

  components: {
    Analysis: () => import("@/views/em/components/Analysis"),
    WorkorderInfo: () => import("@/views/pp/components/WorkorderInfo"),
    StationMember,
  },

  data() {
    return {
      show: false,
      wrapperClosable: true,
      direction: "rtl",
      loading: false,
      nopic: require("@/assets/no-pic.png"),
      activeName: "first",
      station: {
        stationid: null,
        godid: null,
        station_no: "",
        station_title: "",
        remark: "",
        equipid: null,
        bind_enable: null,
        qr_code_url: "",
        equip: {},
      },
      stationid: null,
    };
  },
  computed: {
    hasEquip() {
      return (
        this.station.hasOwnProperty("equip") &&
        this.station.equip.hasOwnProperty("equipid")
      );
    },
  },
  created() {},

  methods: {
    open({ stationid }) {
      this.show = true;
      this.stationid = stationid;
      this.fetchStation(stationid);
      // this.fetchData(stationid);
    },

    fetchStation(stationid) {
      this.loading = true;
      getStationApi({ stationid: stationid }).then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.station = Object.assign({}, res.data.station, {
            random: stationid + "-" + +new Date(),
          });
        }
      });
    },

    handleClose(done) {
      this.activeName = "first";
      this.station = Object.assign({});
      done();
    },
  },
};
</script>

<style lang="scss" scoped>
$--color-active-bg: #f5f7fa;
$--color-text-muted: #999999;
$--color-danger: #f56c6c;

/deep/ .el-drawer__header {
  margin-bottom: 0;
}

/deep/ .el-drawer__body {
  padding: 0px;
  margin-bottom: 20px;
}

/deep/.el-tabs__content {
  overflow: visible;
}

/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #e4e7ed;
}

.station-detail {
  user-select: none;

  /deep/.el-drawer__body {
    margin: 0;
    .el-tabs__header {
      margin: 0 30px 15px;
    }
    .preview {
      position: relative;
      width: 245px;
      height: 187px;
      margin: 8px 0;
      border-radius: 6px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;

      .comm-tags {
        .comm-tag {
          height: 31px;
          line-height: 31px;
          border-radius: 6px 0px 6px 0px;
        }
      }

      .updatetime {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 245px;
        height: 35px;
        border-radius: 0px 0px 6px 6px;
        background-color: rgba(16, 16, 16, 0.5);
        color: #fff;

        > i {
          font-size: 15px;
        }
      }
    }
  }
}
</style>
